import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

/**
 * for this page
 */
import TabTitle from '../../../../components/tabTitle';

class LhbTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        current: this.props.content.current,
        totalLen: this.props.content.data[this.props.content.current].data.length,
        showLen: 30,
    };

    handleMouseOver = index => {
        if (index !== this.state.current) {
            this.setState({
                current: index,
                totalLen: this.props.content.data[index].data.length,
                showLen: 30,
            });
        }
    };

    handleMore = () => {
        const { totalLen, showLen } = this.state;

        if (showLen < totalLen) {
            this.setState({
                showLen: showLen + 30,
            });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { title, tabTits, data } = this.props.content;
        const { current, totalLen, showLen } = this.state;

        return (
            <div className={styles.tab}>
                <TabTitle title={title} tabTits={tabTits} current={current} callback={this.handleMouseOver} />
                <div className={styles.list}>
                    <div className={styles.time}>{data[current].date}</div>
                    <ul className="clearfix">
                        {data[current].data.slice(0, showLen).map((item, index) => (
                            <li key={index} className="clearfix">
                                <p>
                                    <a href={item.url} rel={rel} target="_blank">
                                        {item.name}
                                    </a>
                                </p>
                                <p className={item.num.slice(0, item.num.length - 1) * 1 < 0 ? styles.green : ''}>
                                    {item.num}
                                </p>
                            </li>
                        ))}
                    </ul>
                    {data[current].data.length === 0 && (
                        <p className={styles.empty}>今日{tabTits[current].name}龙虎榜数据暂未公布</p>
                    )}
                    <div className={styles.more} onClick={this.handleMore}>
                        {showLen < totalLen ? '查看更多' : '已显示全部'}
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(LhbTable);
